import React, { useState } from "react";
import { DotsLoader } from "../../ui/Loader/dotsLoader";

const FMHtml = ({ message }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  if (!message) return null;

  const url = message?.options?.url || message?.url || "";

  if (url) {
    return (
      <div style={{ width: "100%", height: "100%", marginTop: "20px", position: "relative" }}>
        {/* Default loader - shows immediately */}
        {!iframeLoaded && (
          <div >
            <DotsLoader />
          </div>
        )}
        <iframe
          src={url}
          title={message?.options?.title || "HTML Content"}
          style={{
            width: "100%",
            height: message?.options?.height ? `${message.options.height}px` : "85vh",
            borderRadius: "8px",
            opacity: iframeLoaded ? 1 : 0,
            transition: "opacity 0.3s ease-in-out",
            visibility: iframeLoaded ? "visible" : "hidden"
          }}
          onLoad={() => {
            console.log("Iframe loaded successfully");
            setIframeLoaded(true);
          }}
          onError={(e) => {
            console.log("Iframe error:", e);
            setIframeLoaded(true);
          }}
        />
      </div>
    );
  }

  return (
    <div style={{ padding: "20px", background: "#ffcccc" }}>
     No content to display
      <pre>{JSON.stringify(message, null, 2)}</pre>
    </div>
  );
};

export default FMHtml;
